import String from './String'

export default class extends String {
  mutator (value) {
    value = super.mutator(value)

    if (/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/.test(value)) {
      return value
    }
  }
}
